/** Shared callout styling for inline section optimization feedback (left editor). */
export const SECTION_FEEDBACK_CALLOUT_CLASS =
  'rounded-lg border border-amber-200 bg-amber-50/80 px-3 py-2 scroll-mt-14'

/** Wrapper below section header: stacks feedback callouts with spacing before editor content. */
export const SECTION_FEEDBACK_STACK_CLASS = 'mb-3 space-y-3'

export const SECTION_FEEDBACK_TITLE_CLASS = 'text-sm font-medium text-amber-950'

export const SECTION_FEEDBACK_LIST_CLASS =
  'ml-1 list-disc list-outside space-y-1 pl-4 text-sm text-amber-900/95'
